import styled from 'styled-components';

export const MaxWidthContainer = styled.div`
	padding: 30px;
	max-width: 1024px;
	margin: 0 auto;
`;

export const Layout = styled(MaxWidthContainer)`
	flex-wrap: wrap;
	display: flex;
	justify-content: space-between;
`;

export const Block = styled.div`
	width: calc(50% - 15px);
	margin-bottom: 30px;
	display: flex;
	
	div {
		width: 100%;
	}
	
	&.is-full-width {
		width: 100%;
	}
`;

export const CardContent = styled.div`
	padding: 20px;
`;

export const List = styled.dl`	
	list-style: none;
	padding: 0;
	margin: 0;
	
	li {
		margin-bottom: 10px;
	}
`;


// WEBPACK FOOTER //
// ./src/components/styled/index.js